import Checkmark from '../../src/legacy/Checkmark';
export default Checkmark;
